import React, {  useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import NavBar from '../components/NavBar'
import { ArrowRight, Check, Star, ChevronRight, ChevronDown, Users, Clock, Layout } from 'lucide-react'
import { TemplatesData } from '../lib/TemplatesData'

// const features = [
//   {
//     title: "Smart Formatting",
//     description: "ATS-friendly templates that boost your visibility to employers",
//     icon: "Smart Templates"
//   },
//   {
//     title: "AI Suggestions",
//     description: "Get real-time recommendations to improve your content",
//     icon: "AI"
//   },
//   {
//     title: "Multiple Formats",
//     description: "Export to PDF, Word, or share online instantly",
//     icon: "PDF"
//   }
// ]

const steps = [
  {
    number: "01",
    title: "Choose Your Template",
    description: "Select from our professionally designed templates"
  },
  {
    number: "02",
    title: "Add Your Information",
    description: "Fill in your details with our smart editor"
  },
  {
    number: "03",
    title: "Download & Share",
    description: "Get your resume in PDF or share online"
  }
]

// const templates = [
//   {
//     name: "Modern Professional",
//     category: "Professional",
//     image: "/placeholder.svg?height=400&width=300",
//     suitableFor: "Perfect for Tech & Business"
//   },
//   {
//     name: "Creative Portfolio",
//     category: "Creative",
//     image: "/placeholder.svg?height=400&width=300",
//     suitableFor: "Ideal for Design & Media"
//   },
//   {
//     name: "Executive Suite",
//     category: "Professional",
//     image: "/placeholder.svg?height=400&width=300",
//     suitableFor: "Best for Senior Roles"
//   }
// ]


const testimonials = [
  {
    quote: "Landed my dream job at Google in just 2 weeks!",
    author: "Sarah K.",
    role: "Software Engineer",
    rating: 5
  },
  {
    quote: "The AI suggestions were game-changing for my resume.",
    author: "Michael R.",
    role: "Marketing Director",
    rating: 5
  },
  {
    quote: "Simple, effective, and professional templates.",
    author: "Jessica T.",
    role: "UX Designer",
    rating: 5
  }
]

const faqItems = [
  {
    question: "Is it free to use?",
    answer: "Yes! You can create and download your first resume completely free. Premium features are available for advanced needs.",
    isOpen: false
  },
  {
    question: "What is ATS, and why does it matter?",
    answer: "ATS (Applicant Tracking System) is software used by employers to screen resumes. Our templates are optimized to pass these systems and get your resume seen by human recruiters.",
    isOpen: false
  },
  {
    question: "Can I edit my resume later?",
    answer: "Your resume is saved securely in your account and can be edited anytime. Make updates and download a new copy whenever you need.",
    isOpen: false
  }
]

const LandingPage = () => {
  const [faqList, setFaqList] = useState(faqItems)
  // const [isOpen, setIsOpen] = useState(false);

  const ref = useRef(null);



  const handleFilterOpening = (index) => {
    const data = [...faqList]
    console.log(data[index].isOpen)
    const isOpen = data[index].isOpen
    data[index] = {
      ...data[index],
      isOpen: !isOpen,
      height: isOpen ? 0 : ref.current?.getBoundingClientRect().height
    }
    console.log(data)
    setFaqList(data)
  };




  // const handleAccordion = (index) => {
  //   const data = [...faqList]
  //   console.log(data[index].isOpen)
  //   data[index] = {
  //     ...data[index],
  //     isOpen: data[index].isOpen ? false : true
  //   }
  //   console.log(data)
  //   setFaqList(data)
  // }


  return (
    <div className='min-h-screen bg-gradient-to-b from-blue-50 via-white to-blue-50 relative overflow-hidden'>
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-blue-50 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-[800px] h-[800px] bg-blue-50 rounded-full translate-y-1/2 -translate-x-1/2" />

      <NavBar />

    

      {/* <div className='h-full max-w-5xl flex flex-col justify-center items-center mx-auto font-bold'>
        <div className='hidden md:block px-5 py-7 rounded-lg font-bold shadow-2xl absolute top-[290px] left-[90px] rotate-[-9deg] bg-white/90 backdrop-blur-xs'>
          <FaRegFileAlt size={30} />
          <span>Professional templates ready to use</span>
        </div>

        <div className='hidden md:block px-5 py-7 rounded-lg font-bold shadow-2xl absolute top-[430px] left-[150px] rotate-[-7deg] bg-white/90 backdrop-blur-xs'>
          <MdSupervisorAccount size={30} color='blue' />
          <span>Trusted by thousands of professionals</span>
        </div>

        <div className='hidden md:block px-5 py-5 rounded-lg font-bold shadow-2xl absolute top-[300px] right-[80px] rotate-[7deg] bg-white/90 backdrop-blur-xs'>
          <span className='text-yellow-500'><CiStar size={35} /></span>
          <span>Stand out from other candidates</span>
        </div>

        <h1 className='text-center text-4xl md:text-6xl'> Create your professional resume
          <br />
          <span className='text-muted-foreground'>in minutes</span>
        </h1>

        <p className='text-center mt-7 max-w-[600px] md:text-xl text-muted-foreground font-normal'>Build a stunning resume that gets you noticed. Choose from professional templates,
          customize your content, and download.
        </p>

        <Link to="/select-template" className='mt-10 bg-black text-white px-6 py-3 rounded-md text-sm flex items-center'>
          <button className='mr-2'>
            Create Your Resume
          </button>
          <FaArrowRight color='grey' />
        </Link>
      </div> */}

      {/* Hero Section */}
      <section className="relative pt-16 pb-32">
        <div className="max-w-4xl mx-auto text-center mb-10">
          <h1 className="text-5xl md:text-6xl font-normal tracking-tight mb-6 animate-fade-in">
            Build Your Perfect Resume in Minutes!
          </h1>
          <p className="text-lg text-gray-600 animate-fade-in animation-delay-200">
            Take control of your career with tailored resumes that land interviews!
          </p>
          <Link to={"/select-template"}>
            <button className="mt-8 flex mx-auto text-white text-sm items-center rounded-full px-8 py-4 bg-blue-600 hover:bg-blue-700 animate-fade-in animation-delay-300">
              Start Building Now – It's Free!
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Stats div */}
          <div className="p-6 bg-white shadow-xl rounded-3xl animate-fade-in animation-delay-300">
            <div className="space-y-2">
              <p className="text-sm text-gray-600">Save Time</p>
              {/* <div className="text-4xl font-semibold">50%</div> */}
              <div className="text-sm text-gray-600">Create a professional resume in less than 10 minutes!</div>
            </div>
            <div className="mt-4">
              <svg className="w-full h-24" viewBox="0 0 200 100">
                <path
                  d="M0 80 Q 50 40 100 60 T 200 40"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className="text-green-500"
                />
              </svg>
            </div>
          </div>

          {/* Features div */}
          <div className="p-6 bg-white shadow-lg rounded-3xl animate-fade-in animation-delay-400">
            <div className="space-y-4">
              <div className='text-lg font-medium flex items-center'>
                <Check className="h-5 w-5 mr-2 text-green-500" />
                Why Choose Us?
              </div>

              <div className='space-y-2'>
                <p className="flex items-center text-sm">
                  <Layout className="h-4 w-4 mr-2 text-green-500" />
                  <span>Smart Templates: Professionally designed</span>
                </p>
                <p className="flex items-center text-sm">
                  <Clock className="h-4 w-4 mr-2 text-green-500" />
                  <span>Time-Saving: Create resumes in minutes</span>
                </p>
                <p className="flex items-center text-sm">
                  <Users className="h-4 w-4 mr-2 text-green-500" />
                  <span>User-Friendly: For beginners to experts</span>
                </p>
              </div>
            </div>
          </div>

          {/* Insights div */}
          <div className="p-6 bg-white shadow-lg rounded-3xl animate-fade-in animation-delay-500">

            <div className="bg-yellow-100 text-yellow-800 text-sm font-medium px-2.5 py-0.5 mb-2 rounded-full inline-block">Coming Soon</div>

            <div className="space-y-4">
              <h3 className="text-xl font-medium">AI-Powered Insights</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <Check className="h-4 w-4 text-green-500" />
                  <span className="text-sm text-gray-600">Keyword optimization</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Check className="h-4 w-4 text-green-500" />
                  <span className="text-sm text-gray-600">Industry targeting</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Check className="h-4 w-4 text-green-500" />
                  <span className="text-sm text-gray-600">Experience highlights</span>
                </div>
              </div>
              {/* <button variant="ghost" className="flex items-center w-full justify-between mt-4 hover:bg-gray-300/30 px-3 py-2">
                Get AI tips now
                <ArrowRight className="h-4 w-4" />
              </button> */}
            </div>
          </div>
        </div>


      </section>

      {/* How It Works */}
      <section className="py-20 bg-white relative z-10">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-normal text-center mb-16">How It Works</h2>
          <div className=" grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="text-6xl font-light text-blue-100 mb-4">{step.number}</div>
                <h3 className="text-xl font-medium mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
                {index < steps.length - 1 && (
                  <ChevronRight className="hidden md:block h-8 w-8 text-gray-300 absolute top-1/2 -right-4 transform -translate-y-1/2" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Template Showcase */}
      <section className="py-20 relative z-10">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-normal text-center mb-16">Professional Templates</h2>
          <div className="max-w-7xl mx-auto">
            <div className='grid grid-cols-3 justify-evenly gap-32'>
              {TemplatesData.map((template, index) => {

                return (
                  <div className='border shadow-lg rounded-lg w-[350px]'>
                    <img
                      src={template.src}
                      alt={template.name}
                      width={350}
                      height={400}
                      className="rounded-lg border-b"
                    />

                    {/* <div className="p-4">
                      <h3 className="font-medium">{template.name}</h3>
                      <p className="text-sm text-gray-600">{template.suitableFor}</p>
                    </div> */}

                  </div>)
              })}
            </div>
          </div>
        </div>
      </section>


      {/* Testimonials */}
      <section className="py-20 bg-white relative z-10">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-normal text-center mb-16">What Our Users Say</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="p-6 border rounded-lg shadow-md">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-600 mb-4">"{testimonial.quote}"</p>
                <div>
                  <div className="font-medium">{testimonial.author}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 relative z-10">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-normal text-center mb-16">Frequently Asked Questions</h2>
          <div className="max-w-3xl mx-auto">
            <div id="accordion-collapse" data-accordion="collapse">
              {faqList.map((item, index) => (
                <div>
                  <h2>
                    <button onClick={() => handleFilterOpening(index)} type="button" class="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
                      <span>{item.question}</span>
                      <ChevronDown />
                    </button>
                  </h2>
                  <div className='my-collapse' style={{ height: item.height ?? 0 }}>
                    <div ref={ref} class="p-5 border border-b-0 border-gray-200 dark:border-gray-700 dark:bg-gray-900">
                      <p class="mb-2 text-gray-500 dark:text-gray-400">{item.answer}</p>
                      {/* <p class="text-gray-500 dark:text-gray-400">Check out this guide to learn how to <a href="/docs/getting-started/introduction/" class="text-blue-600 dark:text-blue-500 hover:underline">get started</a> and start developing websites even faster with components on top of Tailwind CSS.</p> */}
                    </div>
                  </div>
                </div>


              ))}
            </div>
          </div>
        </div>
      </section> {/* Final CTA */}
      <section className="py-20 bg-blue-600 text-white relative z-10">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-normal mb-6">Ready to Build Your Future?</h2>
          <p className="text-xl mb-8 text-blue-100">Join thousands of successful job seekers today</p>
          <Link to={"/select-template"}>
            <button className="flex justify-center bg-white text-black font-semibold items-center mx-auto rounded-full px-8 py-4">
              Create Your Resume Now
              <ArrowRight className="ml-2 mt-1 h-5 w-5" />
            </button></Link>
        </div>
      </section>
    </div>


  )
}

export default LandingPage